import Api from '../api';

export const totalBiddingUnread = async (company: number, filterId: number | null = null) => {
  try {
    const params: { company: number; filter_id?: number } = { company };
    if (filterId) params.filter_id = filterId;

    const { data } = await Api.get(`/boletim_web/public/boletins/total_bulletin_unread`, {
      params,
    });
    return data?.total_bulletin_unread ?? 0;
  } catch (error) {
    console.error('Erro ao buscar o total de boletins não lidos:', error);
    return 0;
  }
};

export const getPortalsExpired = async (companyId: number) => {
  const { data } = await Api.get(`/manager_portals/portals_expired`, { params: { companyId } });
  return data?.expired_count;
};
